import { FC, useEffect, useState } from 'react'
import { FlexAlignType } from 'react-native'
import { ColorOptions, FontSizeOptions, FontWeightOptions } from '../../theme/UiThemeProvider'
import { useBreakPointProps } from '../../utils/utils'
import { Box } from '../Box'
import { Icon } from '../Icon'
import { LoaderNew } from '../LoaderNew'
import { Spacer } from '../Spacer'
import { Text, TextTypesOptions } from '../Text'

const getIconFont = (isChecked?: boolean) => {
  if (isChecked) {
    return 'CHECKBOX_CHECKED'
  }
  return 'CHECKBOX_UNCHECKED'
}

interface CheckBoxProps {
  textLabel?: string | Array<string>
  color?: ColorOptions | Array<ColorOptions>
  checkedColor?: ColorOptions
  onChange?: (isChecked: string) => (void | Promise<void>) | Array<(isChecked: string) => void | Promise<void>>
  onChecked?: (isChecked: boolean) => void | Array<(isChecked: boolean) => void>
  value?: string | Array<string>
  checked?: boolean | Array<boolean>
  loading?: boolean | Array<boolean>
  testID?: string
  alignBox?: FlexAlignType | Array<FlexAlignType>
  iconSize?: FontSizeOptions | number
  accessibilityLabel?: string
  textStyle?: TextTypesOptions
  textColor?: ColorOptions
  fontWeight?: FontWeightOptions
  disabled?: boolean
  fontSize?: any
  singleLine?: boolean
}

export const CheckBox: FC<CheckBoxProps> = (props) => {
  const modifiedProps = useBreakPointProps<CheckBoxProps>(props)
  const {
    textLabel = '',
    color = 'PRIMARY',
    onChange: onPress,
    onChecked,
    checked,
    loading: propsLoading,
    value,
    testID,
    alignBox = 'center',
    iconSize = 'FONT_SIZE_EXTRA_LARGE',
    accessibilityLabel,
    textStyle = 'h2Light',
    textColor = 'BLACK',
    fontWeight = '600',
    disabled = false,
    fontSize = 16,
    singleLine = false,
    checkedColor,
  } = modifiedProps
  let isCheck = checked
  const [isLoading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(!!propsLoading)
  }, [propsLoading])
  if (value !== undefined) {
    isCheck = value === 'true'
  }

  const onSelected = async () => {
    if (onChecked) {
      onChecked(!isCheck)
    }
    if (onPress && !isLoading) {
      setLoading(true)
      await onPress(isCheck ? 'false' : 'true')
      setLoading(false)
    }
  }
  return (
    <Box flexDirection="row" alignItems={alignBox}>
      {!isLoading && (
        <Box
          underlayColor="LIGHTEST_GREY_2"
          disabled={disabled}
          onPress={onSelected}
          testID={testID}
          opacity={disabled ? 0.5 : 1}
          accessibilityLabel={isCheck ? 'checked' : 'unchecked'}>
          <Icon id={getIconFont(isCheck as boolean)} color={color as ColorOptions} size={iconSize} />
        </Box>
      )}
      {isLoading && <LoaderNew color={color as ColorOptions} />}
      {textLabel !== '' && (
        <>
          <Spacer direction="horizontal" size={8} />
          <Text
            fontWeight={fontWeight as FontWeightOptions}
            type={textStyle as TextTypesOptions}
            title={textLabel as string}
            color={textColor as ColorOptions}
            fontSize={fontSize}
            ellipsizeMode={singleLine ? 'tail' : undefined}
            numberOfLines={singleLine ? 1 : undefined}
          />
        </>
      )}
    </Box>
  )
}
